// libs
import React, { memo, useEffect, useRef, useContext } from 'react';

// contexts
import VirtualizeContext from 'shared/components/Virtualize/VirtualizeContext';

// defs
interface IMeasureRowProps {
  children: React.ReactNode;
  onMeasured: (height: number) => void;
}

/**
 * Measure Row height - to be used inside Virtualize
 */
function MeasureRowHeight({ children, onMeasured }: IMeasureRowProps) {
  const elRef = useRef<HTMLDivElement>(null);
  const { width } = useContext(VirtualizeContext);

  useEffect(() => {
    if (elRef.current !== null) {
      const { height } = elRef.current.getBoundingClientRect();
      onMeasured(height);
    }
  }, [onMeasured, width]);

  if (width === 0) {
    return null;
  }

  return (
    <div
      style={{
        width: `${width}px`,
        position: 'absolute',
        visibility: 'hidden',
        left: '-999px',
      }}
      ref={elRef}
    >
      {children}
    </div>
  );
}

export default memo(MeasureRowHeight);
